import {Component} from '@angular/core';
import {BaseComponent} from "../base.component";
import {Router} from "@angular/router";
import {AuthService} from "../auth/auth.service";
import {ControlContainer, NgForm} from "@angular/forms";
import {UserModel} from "../base.model";

/**
 * App-Component
 */
@Component({
    selector: 'skitbs-users',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}],
    template: `
        <div *ngFor="let pUser of modelUsers; last as isLast">
            <div class="d-flex BsWid300p">
                <i class="pi pi-user MarR"></i>
                <div class="d-col MarH" (click)="onSelectUser(pUser)">
                    <span><b>{{pUser.authXBVO.tgFirstname + " " + pUser.authXBVO.tgLastname}}</b></span>
                    <br/>
                    <span>Vertrag {{pUser.authXBVO.cpNr + " [" + pUser.authXBVO.tenantNr + "]"}}</span>
                </div>
                <a class="MarR" *ngIf="isLast" (click)="onAddUser()" class="MarH"><i class="pi pi-plus-circle Green FontBold"></i></a>
                <a class="MarL" (click)="onRemoveUser(pUser)"><i class="pi pi-trash Red MarL"></i></a>
                <br/>
            </div>
            <div class="EmptyBox20"></div>
        </div>
        <div class="user-terminate-contract d-flex BsWid300p" (click)="onTerminateContract()">
            <i class="pi pi-file-excel MarR"></i>
            <span>{{v('menu_terminate')}}</span>
        </div>

    `
})
export class UserSwitchComponent extends BaseComponent {

    modelUsers: UserModel[] = [];

    /**
     * Constructor.
     * @param restClient
     */
    constructor(private router: Router, private authService: AuthService) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        this.loadUsers();
    }

    /**
     * Loads.
     * @private
     */
    private loadUsers() {
        this.modelUsers = this.authService.findUserHistory();
    }

    /**
     * Action
     * @param aUser
     */
    public onSelectUser(aUser: UserModel) {
        this.authService.switchUser(aUser.authXBVO);
        this.redirectTo(this.router, "/orders");
    }

    /**
     * Action
     * @param aUser
     */
    public onRemoveUser(aUser: UserModel) {
        this.authService.removeUserHistory(aUser);
        this.loadUsers();
        this.authService.logout();
    }

    /**
     * Action.
     */
    onAddUser() {
        this.toastInfoSticky(this.i18n.v("new_user_hint"));
        this.router.navigate(['/login']);
    }

    onTerminateContract() {
        this.router.navigate(['/contract-termination']);
    }
}
